import Typography from "@mui/material/Typography";
import { EtaxStatusBadge } from "../ETax/documentCells";
import { NoteEtaxSource, hasNoteEtaxState } from "./noteEtaxState";

/** Where the note's e-Tax document stands, in the words of the E-Tax page's status chip. */
export default function NoteEtaxStatus({ note }: Readonly<{ note: NoteEtaxSource }>) {
  if (!hasNoteEtaxState(note)) {
    return (
      <Typography variant="body2" color="text.secondary">
        -
      </Typography>
    );
  }

  return (
    <EtaxStatusBadge
      status={note.etax_status ?? null}
      documentStatus={note.document_status ?? null}
      isPaper={note.etax_enabled === false}
    />
  );
}
